import type { TinyTableV2Data } from './TinyTableV2';

import TinyTableV2 from './TinyTableV2';

export type { TinyTableV2Data };

export default TinyTableV2;
